// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7775) return "css/Template2.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 628) return "css/Template3.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 9245) return "css/MobileTemplate1.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 2437) return "css/aiAgentV2.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 7866) return "css/aiAgent.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 1399) return "packages/reactflow@11.8.3/reactflow.3dbee60b-db35-41c8-a7ae-adf59fd76c44.bundle.css";
	if (chunkId === 4149) return "packages/@wangeditor@5.0.1/@wangeditor.3dbee60b-db35-41c8-a7ae-adf59fd76c44.bundle.css";
	if (chunkId === 3339) return "packages/icp-mining@3.0.49/icp-mining.3dbee60b-db35-41c8-a7ae-adf59fd76c44.bundle.css";
	if (chunkId === 8309) return "css/saas-ui-chat.3dbee60b-db35-41c8-a7ae-adf59fd76c44.chunk.css";
	if (chunkId === 5299) return "packages/icp-form-designer@3.0.49/icp-form-designer.3dbee60b-db35-41c8-a7ae-adf59fd76c44.bundle.css";
	// return url for filenames based on template
	return undefined;
};